// extracted by mini-css-extract-plugin
export default {"intro":"Intro_intro__kPLRM","intro__characters":"Intro_intro__characters__XPK27","intro__text":"Intro_intro__text__TdRpj"};